import { type GridColDef } from "@mui/x-data-grid";

import { MailListMember } from "api/memberPortal/mailList/mailList.types";
import SyncStatus from "features/memberPortal/mail/components/SyncStatus/SyncStatus";
import { standardDateFormat } from "utils/timeUtils";

export const mailListMemberColumns: GridColDef<MailListMember>[] = [
  {
    field: "name",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 2,
  },
  {
    field: "dateAdded",
    headerName: "Date Added",
    align: "center",
    flex: 1,
    valueFormatter: (value) => standardDateFormat(value),
  },
  {
    field: "syncStatus",
    flex: 0,
    headerName: "Sync",
    headerAlign: "center",
    align: "center",
    sortable: true,
    renderCell: ({ value }) => <SyncStatus status={value} />,
  },
];
